'use strict';

var React = require('react');
require('../../theme/breakpoints.js');
require('imask');
var useIsomorphicLayoutEffect = require('../../hooks/useIsomorphicLayoutEffect.js');
var useRefAndForward = require('../../hooks/useRefAndForward.js');
require('resize-observer-polyfill');
var component = require('../Text/component.js');
var styles = require('./styles.js');
var helpers = require('./helpers.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const TreeHeading = React.forwardRef(({ children, ...props }, ref) => {
    const divRef = useRefAndForward.useRefAndForward(null, ref);
    const [errored, setErrored] = React.useState(false);
    useIsomorphicLayoutEffect.useIsomorphicLayoutEffect(() => {
        const div = divRef.current;
        if (!div)
            return;
        const nextErrored = !!div.parentElement?.querySelector(`.${helpers.treeItemErrorClassName}`);
        if (nextErrored !== errored)
            setErrored(nextErrored);
    });
    return (React__default.default.createElement(component.Text, { as: "div", variant: "body", ...props, ref: divRef },
        React__default.default.createElement(styles.Styled.Heading, { errored: errored }, children)));
});
TreeHeading.displayName = 'Tree.Heading';

exports.TreeHeading = TreeHeading;
//# sourceMappingURL=Heading.js.map
